import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler, showSuccess } from 'utils';

import giftApi from 'api/giftApi';
import * as ActionTypes from './actionTypes';
import {
  actionCreateGiftFailed,
  actionCreateGiftSuccess,
  actionDeleteGiftFailed,
  actionDeleteGiftSuccess,
  actionGetGiftDetailsFailed,
  actionGetGiftDetailsSuccess,
  actionGetGiftsFailed,
  actionGetGiftsSuccess,
  actionUpdateGiftFailed,
  actionUpdateGiftSuccess,
  actionGetUserGiftsFailed,
  actionGetUserGiftsSuccess,
} from './actions';

function* createGift({ payload }) {
  try {
    const response = yield giftApi.createGift(payload.payload);
    const result = response?.payload ?? response;
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(actionCreateGiftSuccess(result));
    showSuccess('Tạo quà tặng thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionCreateGiftFailed(error));
  }
}

function* getGiftDetails({ payload }) {
  try {
    const response = yield giftApi.getGiftDetails(payload.id);
    const result = response?.payload ?? response;
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(actionGetGiftDetailsSuccess(result));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetGiftDetailsFailed(error));
  }
}

function* updateGift({ payload }) {
  try {
    const response = yield giftApi.updateGift(payload.id, payload.payload);
    const result = response?.payload ?? response;
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(actionUpdateGiftSuccess(result));
    showSuccess('Cập nhật quà tặng thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionUpdateGiftFailed(error));
  }
}

function* deleteGift({ payload }) {
  try {
    const response = yield giftApi.deleteGift(payload.id);
    const result = response?.payload ?? response;
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(actionDeleteGiftSuccess(result));
    showSuccess('Xóa quà tặng thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionDeleteGiftFailed(error));
  }
}

function* getGifts({ payload }) {
  try {
    const response = yield giftApi.getGifts(payload.payload);
    const result = response?.payload ?? response;
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(actionGetGiftsSuccess(result));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetGiftsFailed(error));
  }
}

function* getUserGifts({ payload }) {
  try {
    const response = yield giftApi.getUserGifts(payload.payload);
    const result = response?.payload ?? response;
    if (payload.callback) {
      payload.callback(result);
    }
    yield put(actionGetUserGiftsSuccess(result));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetUserGiftsFailed(error));
  }
}

export default function* giftSaga() {
  yield takeLeading(ActionTypes.CREATE_GIFT, createGift);
  yield takeLeading(ActionTypes.GET_GIFT_DETAILS, getGiftDetails);
  yield takeLeading(ActionTypes.UPDATE_GIFT, updateGift);
  yield takeLeading(ActionTypes.DELETE_GIFT, deleteGift);
  yield takeLeading(ActionTypes.GET_GIFTS, getGifts);
  yield takeLeading(ActionTypes.GET_USER_GIFTS, getUserGifts);
}
